import script from "./d3.sliceschart.vue?vue&type=script&lang=js"
export * from "./d3.sliceschart.vue?vue&type=script&lang=js"

import "./d3.sliceschart.vue?vue&type=style&index=0&id=fec760aa&lang=scss"

export default script